export default [
    // User type (Super Admin)
    {
        name: 'Dashboard',
        icon: 'nc-icon nc-bank',
        path: '/overview',
        permission: 'Super Admin'
    },
    {
        name: 'Users',
        icon: 'nc-icon nc-single-02',
        path: '/users/list',
        permission: 'Super Admin'
    },
    {
        name: 'Import Farmers',
        icon: 'nc-icon nc-single-copy-04',
        path: '/import/farmers',
        permission: 'Super Admin'
    },
    {
        name: 'Categories',
        icon: 'nc-icon nc-book-bookmark',
        path: '/categories/list',
        permission: 'Super Admin'
    },
    {
        name: 'Pages',
        icon: 'nc-icon nc-forms',
        path: '/page/list',
        permission: 'Super Admin'
    },
    {
        name: 'Crops',
        icon: 'nc-icon nc-shop',
        path: '/crops',
        permission: 'Super Admin'
    },
    {
        name: 'Country',
        icon: 'nc-icon nc-globe',
        path: '/country',
        permission: 'Super Admin'
    },
    {
        name: 'Packages',
        icon: 'nc-icon nc-check-2',
        path: '/packages',
        permission: 'Super Admin'
    },
    {
        name: 'Post Template',
        icon: 'nc-icon nc-compass-05',
        path: '/pageTemplate/list',
        permission: 'Super Admin'
    },
    {
        name: 'Forms',
        icon: 'nc-icon nc-diamond',
        path: '/forms/list',
        permission: 'Super Admin'
    },
    {
        name: 'Reports',
        icon: 'nc-icon nc-chart-bar-32',
        path: '/report/page',
        permission: 'Super Admin'
    },


    // user type (Manager) routes -> manages NGO per country eg FFF in Ghana
    {
        name: 'Dashboard',
        icon: 'nc-icon nc-bank',
        path: '/overview',
        permission: 'Manager'
    },
    {
        name: 'Users',
        icon: 'nc-icon nc-single-02',
        path: '/users/list',
        permission: 'Manager'
    },
    {
        name: 'Import Farmers',
        icon: 'nc-icon nc-single-copy-04',
        path: '/import/farmers',
        permission: 'Manager'
    },
    {
        name: 'Forms',
        icon: 'nc-icon nc-diamond',
        path: '/forms/list',
        permission: 'Manager'
    },
    {
        name: 'Reports',
        icon: 'nc-icon nc-chart-bar-32',
        path: '/report/page',
        permission: 'Manager'
    },
    


    // Role Admin can see all records on FFF in any country
    {
        name: 'Dashboard',
        icon: 'nc-icon nc-bank',
        path: '/overview',
        permission: 'Admin'
    },
    {
        name: 'Users',
        icon: 'nc-icon nc-single-02',
        path: '/users/list',
        permission: 'Admin'
    },
    {
        name: 'Pages',
        icon: 'nc-icon nc-forms',
        path: '/page/list',
        permission: 'Admin'
    },
    {
        name: 'Crops',
        icon: 'nc-icon nc-shop',
        path: '/crops',
        permission: 'Admin'
    },
    {
        name: 'Country',
        icon: 'nc-icon nc-globe',
        path: '/country',
        permission: 'Admin'
    },
    {
        name: 'Import Farmers',
        icon: 'nc-icon nc-single-copy-04',
        path: '/import/farmers',
        permission: 'Admin'
    },
    {
        name: 'Forms',
        icon: 'nc-icon nc-diamond',
        path: '/forms/list',
        permission: 'Admin'
    },
    {
        name: 'Reports',
        icon: 'nc-icon nc-chart-bar-32',
        path: '/report/page',
        permission: 'Admin'
    },

    

    // Trainers role or Users
    {
        name: 'Dashboard',
        icon: 'nc-icon nc-bank',
        path: '/overview',
        permission: 'Trainer'
    },
    {
        name: 'Import Farmers',
        icon: 'nc-icon nc-single-copy-04',
        path: '/import/farmers',
        permission: 'Trainer'
    },
    {
        name: 'Reports',
        icon: 'nc-icon nc-chart-bar-32',
        path: '/report/page',
        permission: 'Trainer'
    },

    // {
    //   name: 'Pages',
    //   icon: 'nc-icon nc-book-bookmark',
    //   children: [
    //     {
    //       name: 'Register',
    //       path: '/register'
    //     },
    //     {
    //       name: 'Lock',
    //       path: '/lock'
    //     }
    //   ]
    // },
    // {
    //     name: 'Trainers',
    //     icon: 'nc-icon nc-hat-3',
    //     path: '/trainer/list',
    //     permission: 'Admin'
    // },
    // {
    //     name: 'Form Template',
    //     icon: 'nc-icon nc-bank',
    //     path: '/forms/list',
    //     permission: 'Manager'
    // },
]